import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './styles/reveal.css';
import Home from "./pages/Home/Home";
import Services from "./pages/Services/Services";
import ServiceDetail from "./pages/Services/ServiceDetail";
import About from "./pages/About/About";
import Solutions from "./pages/Solutions/Solutions";
import Partenaires from "./pages/Partenaires/Partenaires";
import Contact from "./pages/Contact/Contact";
import Careers from "./pages/Careers/Careers";
import Apply from "./pages/Apply/Apply";
import PublicationList from "./pages/Publications/PublicationList";
import PublicationDetail from "./pages/Publications/PublicationDetail";
import Tarifs from "./pages/Tarifs/Tarifs";
import Devis from "./pages/Devis/Devis";
import Header from "./components/Header/Header";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
// import WhatsAppButton from "./components/WhatsApp/WhatsAppButton";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import AnnounceBanner from "./components/AnnounceBanner/AnnounceBanner";
import NotFound from "./pages/NotFound/NotFound";
import MentionsLegales from "./pages/MentionsLegales/MentionsLegales";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  return (
    <>
      <Router>
        <AnnounceBanner />
        <div className="sticky-top">
          <Header />
          <Navbar />
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/partenaires" element={<Partenaires />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/devis" element={<Devis />} />
          <Route path="/publications" element={<PublicationList />} />
          <Route path="/publications/:id" element={<PublicationDetail />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        {/* <WhatsAppButton /> */}
        <ScrollToTop />
        <CookieBanner />
      </Router>
    </>
  );
}

export default App;
